import { render, staticRenderFns } from "./index.vue?vue&type=template&id=beabc0b2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=beabc0b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beabc0b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beabc0b2')) {
      api.createRecord('beabc0b2', component.options)
    } else {
      api.reload('beabc0b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=beabc0b2&scoped=true&", function () {
      api.rerender('beabc0b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/display-zone/modules/addConfig/index.vue"
export default component.exports